import { Stack } from "@mui/material";

import { Button } from "../../components/Button";
import { Text } from "../../components/Text";
import { formatChargeDifferentialPercent } from "../constants";

interface LeadTimeDifferentialRowProps {
  label: string;
  incrementalMultiplier: number;
  isDeleting: boolean;
  onDeleteClick: () => void;
}

export function LeadTimeDifferentialRow(props: LeadTimeDifferentialRowProps) {
  const { label, incrementalMultiplier, isDeleting, onDeleteClick } = props;

  return (
    <Stack
      direction="row"
      spacing={3}
      sx={(theme) => ({
        alignItems: "center",
        paddingY: 2,
        borderBottom: `1px solid ${theme.palette.border?.base ?? theme.palette.divider}`,
        "&:last-of-type": { borderBottom: "none" },
      })}
    >
      <Text sx={{ flex: 1 }} variant="body2">
        {label}
      </Text>
      <Text semibold sx={{ minWidth: 56, textAlign: "right" }} variant="body2">
        {formatChargeDifferentialPercent(incrementalMultiplier)}
      </Text>
      <Button disabled={isDeleting} size="small" variant="outlined" onClick={onDeleteClick}>
        Delete
      </Button>
    </Stack>
  );
}
